import { render, staticRenderFns } from "./ContactUsPage.vue?vue&type=template&id=bd483886&scoped=true&"
import script from "./ContactUsPage.vue?vue&type=script&lang=js&"
export * from "./ContactUsPage.vue?vue&type=script&lang=js&"
import style0 from "./ContactUsPage.vue?vue&type=style&index=0&id=bd483886&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd483886",
  null
  
)

export default component.exports